/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat = ClosedEnum<
  typeof GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat
>;

export type GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat> =
    z.nativeEnum(GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat);

/** @internal */
export const GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat> =
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$ {
  /** @deprecated use `GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$inboundSchema
      .default("json"),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/** @internal */
export type GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsTotalIcEnergyConsumptionRateKwhFormat$outboundSchema
      .default("json"),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$ {
  /** @deprecated use `GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$Outbound` instead. */
  export type Outbound =
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$Outbound;
}

export function getApiV3MetricsTotalIcEnergyConsumptionRateKwhRequestToJSON(
  getApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest:
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$outboundSchema.parse(
      getApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest,
    ),
  );
}

export function getApiV3MetricsTotalIcEnergyConsumptionRateKwhRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsTotalIcEnergyConsumptionRateKwhRequest' from JSON`,
  );
}
